/** Trace 上下文载荷。 */
export type TraceContext = {
  traceId: string;
  sessionId: string;
};

/** 为出站请求创建 Trace 上下文。 */
export function createTraceContext(): TraceContext {
  return {
    traceId: createUuid(),
    sessionId: createUuid(),
  };
}

/** 创建 UUID，兼容非 HTTPS 环境下缺失 crypto.randomUUID 的浏览器。 */
export function createUuid(): string {
  const cryptoApi = globalThis.crypto;
  if (typeof cryptoApi?.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof cryptoApi?.getRandomValues === "function") {
    cryptoApi.getRandomValues(bytes);
  } else {
    fillBytesWithMathRandom(bytes);
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  return formatUuid(bytes);
}

/** 在极旧运行环境中兜底填充随机字节。 */
function fillBytesWithMathRandom(bytes: Uint8Array): void {
  for (let index = 0; index < bytes.length; index += 1) {
    bytes[index] = Math.floor(Math.random() * 256);
  }
}

/** 将 16 字节 UUID 转成标准字符串。 */
function formatUuid(bytes: Uint8Array): string {
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
}

